export const ItemTypes = {
  CARD: "card",
  HERO: "hero",
  IMAGE_WITH_TEXT: "image_with_text",
  NEWSLETTER: "newsletter",
  GALLERY: "gallery",
  TEXT: "text"
};
